import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  bookingGridWrapper: {
    padding: "16px 32px",
  },
  button: {
    cursor: "pointer",
  },
  submitButton: {
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    paddingRight: "20px",
    paddingLeft: "20px",
    minWidth: "183px",
  },
  downloadBookingButton: {
    flexWrap: "nowrap",
    width: "210px",
  },
  markAsReceivedButton: {
    flexWrap: "nowrap",
    width: "243px",
  },
}));

export default styles;
